export var INTERNAL_EVENTS;
(function (INTERNAL_EVENTS) {
    INTERNAL_EVENTS["FsTriggerRendering"] = "FS_TRIGGER_RENDERING";
})(INTERNAL_EVENTS || (INTERNAL_EVENTS = {}));
